import { STATUS_ACTION_TYPE, RESET_ACTION_TYPE } from './constants';

export const actionCreator = ({ name, status, error, statusSubCategoryName }) => ({
  type: STATUS_ACTION_TYPE,
  name,
  status,
  error,
  statusSubCategoryName,
});

export const resetActionCreator = ({ types }) => ({
  type: RESET_ACTION_TYPE,
  types,
});
